import { Route, Routes } from 'react-router-dom';

import Home from '../pages/Home';

import { ROUTES } from '../constants/routes.constants';
import DetallesInscripcion from '../pages/DetallesInscripcion';
import ListadoInscritos from '../pages/ListadoInscritos';

export default function AppRoutes() {
	return (
		<Routes>
			<Route path={ROUTES.HOME} element={<Home />} />
			<Route path={ROUTES.INSCRIPCION_DETALLE} element={<DetallesInscripcion />} />
			<Route path={ROUTES.LISTADO_INSCRITOS} element={<ListadoInscritos />} />
		</Routes>
	);
}
